import '@babel/polyfill'
import React from 'react'
import { render } from 'react-dom'
import Root from './Application/Root/component'

render(<Root />, document.getElementById('app'))
